export default __webpack_public_path__ + "static/media/pictogramFinancialPlanning64.39357a95.svg";